export const pxToRem = (val: number) => {
  return val / 16;
};
export const thousandSeparator = (num: number): string => {
  let prefix: string = '';
  if (num < 0) {
    num *= -1;
    prefix = '-';
  }
  let DIGIT_PATTERN = /(^|\s)\d+(?=\.?\d*($|\s))/g;
  let MILI_PATTERN = /(?=(?!\b)(\d{3})+\.?\b)/g;
  let str: string = num
    .toString()
    .replace(DIGIT_PATTERN, (m) => m.replace(MILI_PATTERN, ' '));
  return prefix + str;
};

export const nbsp = String.fromCharCode(160);

export function isIOS() {
  return (
    [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod',
    ].includes(navigator.platform) ||
    // iPad on iOS 13 detection
    (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
  );
}
